import { fetchClientGeneral } from './fetchClientGeneral';
import { patchClientGeneral } from './patchClientGeneral';
import { fetchClientContentEngine } from './fetchClientContentEngine';
import { patchClientContentEngine } from './patchClientContentEngine';
import { fetchClientProviderConfig } from './fetchClientProviderConfig';
import { patchClientProviderConfig } from './patchClientProviderConfig';
import { fetchClientStudentManagement } from './fetchClientStudentManagement';
import { fetchClientExcursionManagement } from './fetchClientExcursionManagement';
import { fetchClientExcursionManagementVendorsList } from './fetchClientExcursionManagementVendorsList';
import { fetchStudentManagementVendorList } from './fetchStudentManagementVendorList';
import { fetchClientStudentGroupsManagement } from './fetchClientStudentGroupsManagement';
import { fetchClientStudentGroups } from './fetchClientStudentGroups';
import { fetchClientVendorStudentGroups } from './fetchClientVendorStudentGroups';
import { fetchClientStudentManagementGrouping } from './fetchClientStudentManagementGrouping';
import { fetchClientStudentManagementConfig } from './fetchClientStudentManagementConfig';
import { patchClientStudentManagementConfig } from './patchClientStudentManagementConfig';
import { patchClientStudentManagementGrouping } from './patchClientStudentManagementGrouping';
import { postClientStudentManagementGroupingCsvToJson } from './postClientStudentManagementGroupingCsvToJson';
import { fetchClientStudentList } from './fetchClientStudentList';
import { fetchClientBySid } from './fetchClientBySid';
import { patchClientExcursionManagement } from './patchClientExcursionManagement';
import { generateClientSecretKey } from './generateClientSecretKey';
import { patchClientMaintenanceMode } from './patchClientMaintenanceMode';
import { toggleClientMaintenanceMode } from './toggleClientMaintenanceMode';

export default {
  patchClientGeneral,
  fetchClientGeneral,
  fetchClientContentEngine,
  patchClientContentEngine,
  fetchClientProviderConfig,
  patchClientProviderConfig,
  fetchClientStudentManagement,
  fetchClientExcursionManagement,
  patchClientExcursionManagement,
  fetchClientExcursionManagementVendorsList,
  fetchStudentManagementVendorList,
  fetchClientStudentGroupsManagement,
  fetchClientStudentGroups,
  fetchClientVendorStudentGroups,
  fetchClientStudentManagementGrouping,
  fetchClientStudentManagementConfig,
  patchClientStudentManagementConfig,
  patchClientStudentManagementGrouping,
  postClientStudentManagementGroupingCsvToJson,
  fetchClientStudentList,
  fetchClientBySid,
  generateClientSecretKey,
  patchClientMaintenanceMode,
  toggleClientMaintenanceMode
};
